/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

function NavSearch() {
  return (
    <li className="nav-item d-block d-lg-none">
      <a className="nav-link nav-icon search-bar-toggle " href="#">
        <i className="bi bi-search"></i>
      </a>
    </li>
  );
}

export default NavSearch;
